import { numberPositive } from 'Data/validate.js'
import { FEE_MODE_RANGES } from 'Data/constants.js'

export function validateNumber(value) {
  return (
    numberPositive(value) &&
    value >= FEE_MODE_RANGES.PLATFORM_FEE.CARD.MIN &&
    value <= FEE_MODE_RANGES.PLATFORM_FEE.CARD.MAX
  )
}
